import type { IReaction } from '@/api';
import { CommentItem } from '@/features/comments/components/CommentItem';
import type { Comment } from '@/features/comments/types';

interface CommentListProps {
	comments: Comment[];
	onLike: (commentId: number, data: IReaction) => void;
	onReply: (commentId: number) => void;
}

export const CommentList = ({
	comments,
	onLike,
	onReply,
}: CommentListProps) => {
	return (
		<div className="p-4 space-y-4">
			{comments.map((comment) => (
				<CommentItem
					key={comment.id}
					comment={comment}
					onLike={onLike}
					onReply={onReply}
				/>
			))}
		</div>
	);
};
